/**
 * @generated SignedSource<<05e1eaf00f791a3f309c617945b55d70>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RouteConfig_PortalProfile_Query$variables = {};
export type RouteConfig_PortalProfile_Query$data = {
  readonly viewer: {
    readonly user: {
      readonly isPanelist: boolean;
      readonly " $fragmentSpreads": FragmentRefs<"PortalProfile_user">;
    } | null;
  };
};
export type RouteConfig_PortalProfile_Query = {
  response: RouteConfig_PortalProfile_Query$data;
  variables: RouteConfig_PortalProfile_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPanelist",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userSpecified",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "RouteConfig_PortalProfile_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PortalProfile_user"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "RouteConfig_PortalProfile_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PanelistNode",
                "kind": "LinkedField",
                "name": "panelist",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CustomPortalNode",
                    "kind": "LinkedField",
                    "name": "customPanelistPortal",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "contactEmail",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "customColor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fadeBgBottom",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "faviconUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "footerImageUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "headerMarkup",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "headerMarkupEnabled",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "heroAssetUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "heroBackgroundUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hidePanelistProfile",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pageTitle",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "privacyPolicyUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "termsLabel",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "termsUrl",
                        "storageKey": null
                      },
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PersonNode",
                    "kind": "LinkedField",
                    "name": "person",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "avatarUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "firstName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "email",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "phoneNumber",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "requirePhoneNumber",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SelectedResponse",
                    "kind": "LinkedField",
                    "name": "selectedResponses",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CharacteristicNode",
                        "kind": "LinkedField",
                        "name": "characteristic",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CharacteristicElementMetaNode",
                            "kind": "LinkedField",
                            "name": "elementMeta",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "responseValidation",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "target",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "target2",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CharacteristicAnswerNode",
                            "kind": "LinkedField",
                            "name": "answers",
                            "plural": true,
                            "selections": [
                              (v1/*: any*/),
                              (v2/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CharacteristicRowNode",
                            "kind": "LinkedField",
                            "name": "rows",
                            "plural": true,
                            "selections": [
                              (v1/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CharacteristicResponseNode",
                        "kind": "LinkedField",
                        "name": "characteristicResponses",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CharacteristicAnswerNode",
                            "kind": "LinkedField",
                            "name": "answer",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "customAnswer",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CharacteristicRowNode",
                            "kind": "LinkedField",
                            "name": "row",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "textValue",
                            "storageKey": null
                          },
                          (v1/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8b591d083f8dcc777c6e5e9bf7423e14",
    "id": null,
    "metadata": {},
    "name": "RouteConfig_PortalProfile_Query",
    "operationKind": "query",
    "text": "query RouteConfig_PortalProfile_Query {\n  viewer {\n    user {\n      isPanelist\n      ...PortalProfile_user\n      id\n    }\n  }\n}\n\nfragment FormItemCharacteristicResponses_characteristic on CharacteristicNode {\n  id\n  elementMeta {\n    responseValidation\n    target\n    target2\n  }\n  text\n  type\n  ...InputCharacteristicResponses_characteristic\n}\n\nfragment FormItemCharacteristicResponses_characteristicResponses on CharacteristicResponseNode {\n  ...InputCharacteristicResponses_characteristicResponses\n  answer {\n    id\n  }\n  customAnswer\n}\n\nfragment FormPanelistResponses_panelist on PanelistNode {\n  id\n  selectedResponses {\n    characteristic {\n      id\n      text\n      type\n      ...FormItemCharacteristicResponses_characteristic\n    }\n    characteristicResponses {\n      answer {\n        id\n        userSpecified\n      }\n      customAnswer\n      row {\n        id\n      }\n      textValue\n      ...FormItemCharacteristicResponses_characteristicResponses\n      id\n    }\n  }\n}\n\nfragment FormPersonAvatar_person on PersonNode {\n  id\n  avatarUrl\n  firstName\n  lastName\n}\n\nfragment FormPerson_person on PersonNode {\n  id\n  email\n  firstName\n  lastName\n  phoneNumber\n  requirePhoneNumber\n}\n\nfragment InputCharacteristicResponseDate_characteristic on CharacteristicNode {\n  id\n}\n\nfragment InputCharacteristicResponseDate_characteristicResponses on CharacteristicResponseNode {\n  id\n  textValue\n}\n\nfragment InputCharacteristicResponseGridSingleSelect_characteristic on CharacteristicNode {\n  id\n  answers {\n    id\n    text\n  }\n  rows {\n    id\n    text\n  }\n}\n\nfragment InputCharacteristicResponseGridSingleSelect_characteristicResponses on CharacteristicResponseNode {\n  id\n  answer {\n    id\n  }\n  row {\n    id\n  }\n}\n\nfragment InputCharacteristicResponseMultiSelect_characteristic on CharacteristicNode {\n  id\n  answers {\n    id\n    text\n    userSpecified\n  }\n}\n\nfragment InputCharacteristicResponseMultiSelect_characteristicResponses on CharacteristicResponseNode {\n  id\n  customAnswer\n  answer {\n    id\n    userSpecified\n  }\n}\n\nfragment InputCharacteristicResponseNumber_characteristic on CharacteristicNode {\n  id\n  elementMeta {\n    responseValidation\n    target\n    target2\n  }\n}\n\nfragment InputCharacteristicResponseNumber_characteristicResponses on CharacteristicResponseNode {\n  id\n  textValue\n}\n\nfragment InputCharacteristicResponseOpenEnd_characteristic on CharacteristicNode {\n  id\n}\n\nfragment InputCharacteristicResponseOpenEnd_characteristicResponses on CharacteristicResponseNode {\n  id\n  textValue\n}\n\nfragment InputCharacteristicResponseSingleSelect_characteristic on CharacteristicNode {\n  id\n  answers {\n    id\n    text\n    userSpecified\n  }\n}\n\nfragment InputCharacteristicResponseSingleSelect_characteristicResponses on CharacteristicResponseNode {\n  id\n  customAnswer\n  answer {\n    id\n    userSpecified\n  }\n}\n\nfragment InputCharacteristicResponses_characteristic on CharacteristicNode {\n  type\n  ...InputCharacteristicResponseDate_characteristic\n  ...InputCharacteristicResponseGridSingleSelect_characteristic\n  ...InputCharacteristicResponseMultiSelect_characteristic\n  ...InputCharacteristicResponseNumber_characteristic\n  ...InputCharacteristicResponseOpenEnd_characteristic\n  ...InputCharacteristicResponseSingleSelect_characteristic\n}\n\nfragment InputCharacteristicResponses_characteristicResponses on CharacteristicResponseNode {\n  ...InputCharacteristicResponseDate_characteristicResponses\n  ...InputCharacteristicResponseGridSingleSelect_characteristicResponses\n  ...InputCharacteristicResponseMultiSelect_characteristicResponses\n  ...InputCharacteristicResponseNumber_characteristicResponses\n  ...InputCharacteristicResponseOpenEnd_characteristicResponses\n  ...InputCharacteristicResponseSingleSelect_characteristicResponses\n}\n\nfragment PortalProfile_user on UserNode {\n  panelist {\n    id\n    customPanelistPortal {\n      contactEmail\n      customColor\n      fadeBgBottom\n      faviconUrl\n      footerImageUrl\n      headerMarkup\n      headerMarkupEnabled\n      heroAssetUrl\n      heroBackgroundUrl\n      hidePanelistProfile\n      pageTitle\n      privacyPolicyUrl\n      termsLabel\n      termsUrl\n      id\n    }\n    person {\n      id\n      avatarUrl\n      firstName\n      lastName\n      ...FormPerson_person\n      ...FormPersonAvatar_person\n    }\n    ...FormPanelistResponses_panelist\n  }\n}\n"
  }
};
})();

(node as any).hash = "304a81a9ad0866ee515294d6ada972d6";

export default node;
